// extracted by mini-css-extract-plugin
export default {"forgot_pass":"EmailForm_forgot_pass__UdEYK","forgot_text":"EmailForm_forgot_text__YMAQ1","forgot_title":"EmailForm_forgot_title__9X4E-","text_path":"EmailForm_text_path__JMHD-"};